<h1 mat-dialog-title style="margin-bottom: 0px; text-align: center">{{ data.title }}</h1>
<div mat-dialog-content fxLayout="column" fxLayoutAlign="center center">
  <p>{{ data.message }}</p>
  <mat-spinner diameter="32" color="accent"></mat-spinner>
</div>
